export const DELAY_OPTIONS = [
  { value: 15, label: "15 min" },
  { value: 30, label: "30 min" },
  { value: 60, label: "1 hour" },
  { value: 120, label: "2 hours" },
  { value: 240, label: "4 hours" },
] as const;

export const dailyGoalsQueryKey = ["daily-goals"];
export const dashboardQueryKey = ["today-dashboard"];
export const circlesQueryKey = ["circles"];
